import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  > img {
    width: 36px;
    position: absolute;
  }
  > svg {
    width: 20px !important;
    height: 26px !important;
    margin-top: 5px;
    position: absolute;
    color: #757575;
  }
`

export const FileInformation = styled.div`
  padding-left: 43px;
`

export const Filename = styled.div`
  font-size: 12px;
  color: #363636;
  font-weight: 700;
  svg {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    padding: 2px;
    margin-top: 3px;
    margin-left: 10px;
    position: absolute;
    color: white;
    background-color: #0c9159;
  }
`

export const FileSize = styled.div`
  font-size: 12px;
  color: #757575;
`

export const FileActions = styled.div`
  svg {
    cursor: pointer;
    color: #4c4c4c !important;
    float: right;
    margin: 9px 0 9px 16px;
  }
`

interface IProgressBarProps {
  progress: number
}

export const ProgressBar = styled.div<IProgressBarProps>`
  span {
    float: right;
    color: #757575;
    font-size: 12px;
    margin-top: -5px;
  }
  > div {
    height: 8px;
    width: calc(100% - 41px);
    border-radius: 10px;
    margin-top: 12px;
    background-color: #f0f0f0;
    div {
      height: 100%;
      transition: 200ms;
      background-color: #0085ff;
      ${(props) =>
        props.progress < 100
          ? css`
              border-radius: 10px 0px 0px 10px;
            `
          : css`
              border-radius: 10px;
            `}
    }
  }
`

export const Error = styled.div`
  color: #cf1322;
  font-size: 12px;
  margin-top: 8px;
  svg {
    margin-right: 6px;
  }
  span {
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
`
